import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Header from "components/header";
import Footer from "components/Footer";
import { httpReauest } from "utils/httpRequest";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const countryCodes = [
  { code: "1", label: "US" },
  { code: "44", label: "UK" },
  { code: "91", label: "IN" },
  { code: "49", label: "DE" },
  { code: "33", label: "FR" },
  { code: "81", label: "JP" },
  { code: "61", label: "AU" },
  { code: "55", label: "BR" },
  { code: "7", label: "RU" },
  { code: "39", label: "IT" },
  { code: "34", label: "ES" },
  { code: "86", label: "CN" },
  { code: "27", label: "ZA" },
  { code: "82", label: "KR" },
  { code: "31", label: "NL" },
  { code: "64", label: "NZ" },
  { code: "48", label: "PL" },
  { code: "47", label: "NO" },
  { code: "46", label: "SE" },
  { code: "420", label: "CZ" },
  { code: "352", label: "LU" },
  { code: "380", label: "UA" },
  { code: "351", label: "PT" },
  { code: "353", label: "IE" },
  { code: "358", label: "FI" },
  { code: "90", label: "TR" },
  { code: "966", label: "SA" },
  { code: "971", label: "AE" },
  { code: "972", label: "IL" },
  { code: "65", label: "SG" },
  { code: "84", label: "VN" },
  { code: "62", label: "ID" },
  { code: "52", label: "MX" },
  { code: "20", label: "EG" },
  { code: "41", label: "CH" },
  { code: "43", label: "AT" },
  { code: "386", label: "SI" },
  { code: "421", label: "SK" },
  { code: "94", label: "LK" },
  { code: "66", label: "TH" },
  { code: "373", label: "MD" },
  { code: "30", label: "GR" },
  { code: "254", label: "KE" },
  { code: "63", label: "PH" },
  { code: "234", label: "NG" },
  { code: "961", label: "LB" },
  { code: "965", label: "KW" },
  { code: "974", label: "QA" },
  { code: "996", label: "KG" },
  { code: "375", label: "BY" },
  { code: "387", label: "BA" },
  { code: "1", label: "CA" },
  { code: "1", label: "JM" },
  { code: "507", label: "PA" },
  { code: "595", label: "PY" },
  { code: "56", label: "CL" },
  { code: "58", label: "VE" },
  { code: "54", label: "AR" },
];

const Signpage = () => {
  const [step, setStep] = useState(1);
  const [countryCode, setCountryCode] = useState("971"); // پیش‌فرض ایران
  const [t] = useTranslation("global");

  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      navigate("/dashboard");
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      phone: "",
      code: "",
      name: "",
      email: "",
    },
    validationSchema: Yup.object({
      phone: Yup.string()
        .required("Phone number is required")
        // اعتبارسنجی حداقلی برای شماره بدون کد کشور
        .matches(/^[0-9]{8,14}$/, "Invalid phone number"),
      code: Yup.string()
        .required("Code is required")
        .matches(/^[0-9]{6}$/, "Code must be 6 digits"),
      name: Yup.string().required("Name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: async (values) => {
      const user = JSON.parse(localStorage.getItem("user"));

      await httpReauest(
        "POST",
        "/user/info/" + user?._id,
        {
          email: values.email,
          name: values.name,
        },
        { "x-access-token": user?.token }
      )
        .then(() => navigate("/dashboard"))
        .catch(() => toast.error("Something is wrong"));
    },
  });

  const nextStep = async () => {
    const fullPhone = countryCode + formik.values.phone;

    if (step === 1) {
      if (!formik.values.phone) {
        toast.error("Please enter your phone number");
        return;
      }
      try {
        await httpReauest("POST", "/user/login", { phone: fullPhone }, {});
        setStep(step + 1);
      } catch {
        toast.error("Something went wrong with phone login");
      }
    }
    if (step === 2) {
      try {
        const res = await httpReauest(
          "POST",
          "/user/login/accept",
          { phone: fullPhone, code: formik.values.code },
          {}
        );
        localStorage.setItem("user", JSON.stringify(res?.data?.data));
        if (res?.data?.data?.name && res?.data?.data?.nationalCode) {
          navigate("/dashboard");
        } else {
          setStep(step + 1);
        }
      } catch {
        toast.error("Code is wrong");
      }
    }
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  return (
    <>
      <div className="min-h-[80vh] flex items-center justify-center bg-gray-100 mt-[108px] lg:mt-[83px]">
        <Header />
        <form
          onSubmit={formik.handleSubmit}
          className="bg-white px-8 pb-3 rounded-lg shadow-md w-96"
        >
          <img
            src="/logo.png"
            className="w-full max-w-[270px] mx-auto"
            alt="Emporium point logo"
          />
          <h2 className="text-2xl font-bold mb-6 ">{t("sign-login")}</h2>

          {step === 1 && (
            <div>
              <div className="mb-4">
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-gray-700"
                >
                  {t("form-phone")}
                </label>
                <div className="flex items-center space-x-2">
                  <select
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    className="border border-gray-300 rounded-md px-2 py-2"
                  >
                    {countryCodes.map((c) => (
                      <option key={c.code} value={c.code}>
                        {c.label} ({c.code})
                      </option>
                    ))}
                  </select>

                  <input
                    id="phone"
                    name="phone"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.phone}
                    className="flex-1 mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                  />
                </div>
                {formik.touched.phone && formik.errors.phone ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.phone}
                  </div>
                ) : null}
              </div>

              <button
                type="button"
                onClick={nextStep}
                className="w-full bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
              >
                {t("submit")}
              </button>
              <Link
                to={"/sign/partner"}
                onClick={prevStep}
                className="w-full text-center block bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 mt-2"
              >
                {t("sign-as-partner")}
              </Link>
            </div>
          )}

          {step === 2 && (
            <div>
              <p className="mb-3 font-bold">{t("we-send-a-code")}</p>
              <div className="mb-4">
                <label
                  htmlFor="code"
                  className="block text-sm font-medium text-gray-700"
                >
                  {t("code-sended")}
                </label>
                <input
                  id="code"
                  name="code"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.code}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                />
                {formik.touched.code && formik.errors.code ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.code}
                  </div>
                ) : null}
              </div>

              <button
                type="button"
                onClick={prevStep}
                className="w-full bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 mb-2"
              >
                {t("edit-phone")}
              </button>
              <button
                type="button"
                onClick={nextStep}
                className="w-full bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
              >
                {t("submit-code")}
              </button>
            </div>
          )}

          {step === 3 && (
            <div>
              <p className="mb-3 font-bold">{t("complete-info")}</p>
              <div className="mb-4">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  {t("full-name")}
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.name}
                  </div>
                ) : null}
              </div>

              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  {t("checkout.emailLabel")}
                </label>
                <input
                  id="email"
                  name="email"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.email}
                  </div>
                ) : null}
              </div>

              <button
                type="submit"
                className="w-full bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
              >
                {t("submit")}
              </button>
            </div>
          )}
        </form>
      </div>
      <Footer />
    </>
  );
};

export default Signpage;
